import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_COMBO_STICKY_CTA_AND_COPY_EXPERIMENT = defineFcm('psf_combo_sticky_cta_and_copy_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'psf combo (promote-or-share) page',
		description: `Gates the sticky CTA + longer copy experiment on the combo screen
			- experimentName: experiment service name (dynamic so ops can swap iterations without a deploy)`,
		import: false,
		template: {
			experimentName: 'psf_combo_sticky_cta_and_copy_experiment',
		},
	});
